import { Card, Box, Typography, Grid2 } from '@mui/material';
import { ComparePlansButton } from '../../components/pay-wall/ComparePlansButton';
import { HowTosSection } from './HowTosSection';
import { howTosSectionsGroup } from './howTosContent';


export const HowTosPage = () => {

  return (
    <Card sx={{ p: 4, pt: 8 }}>

      <Box display="flex" maxWidth={'100%'} flexDirection='column' gap={1} justifyContent='center' alignItems='center'>
        <Typography sx={styles.pageTitle} gutterBottom>
          {'How To Use My Real Stat'}
        </Typography>
        <Typography sx={styles.sectionTitle} maxWidth={1400} textAlign='center' gutterBottom>
          {`...`}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 4, justifyContent: 'center', alignItems: 'center' }}>
        {howTosSectionsGroup.map((group, index) => (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 8, justifyContent: 'center', alignItems: 'center' }} key={index}>

            <Typography sx={styles.sectionTitle} gutterBottom>
              <span>{`Comes with `}</span>
              <span style={group.groupStyle}>{group.title}</span>
              <span style={{ marginLeft: '20px' }}><ComparePlansButton /></span>
            </Typography>
            <Grid2
              container
              spacing={4}
              sx={{
                marginLeft: 20,
                marginRight: 20,
                justifyContent: "center",
                alignItems: "flex-start",
              }}>
              {group.sections.map((section, index) => (
                <Grid2 size={6} key={index}>
                  <HowTosSection
                    title={section.title}
                    titleStyle={group.groupStyle}
                    image={section.image}
                    description={section.description}
                    comingSoon={section.comingSoon}
                  />
                </Grid2>
              ))}
            </Grid2>
          </Box>
        ))}
      </Box>
    </Card>
  );
};

const styles = {
  pageTitle: { typography: 'h3', },
  sectionTitle: { typography: 'h5', },
  sectionBody: {
    typography: 'h6',
    mb: 2,
    mt: 0,
  }
};